var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEjectSimple = function SvgIconEjectSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.437a1.75 1.75 0 0 0-1.356.644l-.002.001-8.175 10.069-.004.005A1.75 1.75 0 0 0 3.819 16H20.18a1.75 1.75 0 0 0 1.357-2.844l-.005-.005-8.174-10.069-.002-.001A1.75 1.75 0 0 0 12 2.437M4.354 14 12 4.583 19.646 14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconEjectSimple;